// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/images/pattern-white.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================================
                                TABLES OF CSS
===========================================================================*/

a:hover {
    outline: 0;
    text-decoration: none;
}

a:active {
    outline: 0;
    text-decoration: none;
}

a:focus {
    outline: 0;
    text-decoration: none;
}

.container-alt {
    margin-left: auto;
    margin-right: auto;
    padding-left: 15px;
    padding-right: 15px;
}

.dashboard-ds {
    background: #f3f3f3;
    
    color: #5b626b;
    font-size: 13.5px;
}

.slimScrollDiv {
    height: auto !important;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::before {
    background-color: #1b82ec;
}

.social-links li a {
    border-radius: 50%;
    display: inline-block;
    height: 30px;
    line-height: 30px;
    width: 30px;
    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1),
        0 2px 5px rgba(0, 0, 0, 0.15);
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1), 0 2px 5px rgba(0, 0, 0, 0.15);
    text-align: center;
}

.bg-primary {
    background-color: #1b82ec !important;
}

.bg-success {
    background-color: #35a989 !important;
}

.bg-info {
    background-color: #29bbe3 !important;
}

.bg-warning {
    background-color: #f5b225 !important;
}

.bg-danger {
    background-color: #f16c69 !important;
}

.bg-muted {
    background-color: #949a9e !important;
}

.bg-white {
    background-color: #ffffff !important;
}

.text-white {
    color: #ffffff !important;
}

.text-danger {
    color: #f16c69 !important;
}

.text-muted {
    color: #949a9e !important;
}

.text-primary {
    color: #1b82ec !important;
}

.text-warning {
    color: #f5b225 !important;
}

.text-success {
    color: #35a989 !important;
}

.text-info {
    color: #29bbe3 !important;
}


.badge {
    font-weight: 500;
    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
}

.badge-primary {
    background-color: #1b82ec;
}

.badge-success {
    background-color: #35a989;
}

.badge-info {
    background-color: #29bbe3;
}

.badge-warning {
    background-color: #f5b225;
    color: white;
}

.badge-danger {
    background-color: #f16c69;
}

.badge-dark {
    background-color: #2a3142;
}

dt {
    font-weight: 500;
}




.popover {
    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1),
        0 2px 5px rgba(0, 0, 0, 0.15);
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1), 0 2px 5px rgba(0, 0, 0, 0.15);
    border: none;
}

.p-0 {
    padding: 0;
}

.p-t-10 {
    padding-top: 10px;
}

.p-b-10 {
    padding-bottom: 10px;
}

.m-0 {
    margin: 0;
}

.m-r-5 {
    margin-right: 5px;
}

.m-r-10 {
    margin-right: 10px;
}

.m-r-15 {
    margin-right: 15px;
}

.m-l-10 {
    margin-left: 10px;
}

.m-l-15 {
    margin-left: 15px;
}

.m-t-5 {
    margin-top: 5px;
}

.m-t-10 {
    margin-top: 10px;
}

.m-t-15 {
    margin-top: 15px;
}

.m-t-20 {
    margin-top: 20px;
}

.m-t-30 {
    margin-top: 30px;
}

.m-t-40 {
    margin-top: 40px;
}

.m-b-2-force {
    margin-bottom: 2px !important;
}

.m-b-5 {
    margin-bottom: 5px;
}

.m-b-10 {
    margin-bottom: 10px;
}

.m-b-15 {
    margin-bottom: 15px;
}

.m-b-20 {
    margin-bottom: 20px;
}

.m-b-30 {
    margin-bottom: 30px;
}

.w-30 {
    max-width: 30px;
}

.w-xs {
    min-width: 80px;
}

.w-sm {
    min-width: 95px;
}

.w-md {
    min-width: 110px;
}

.w-lg {
    min-width: 140px;
}

.l-h-23 {
    line-height: 23px;
}

.l-h-34 {
    line-height: 34px;
}

.font-12 {
    font-size: 12px;
}

.font-14 {
    font-size: 14px;
}

.font-16 {
    font-size: 16px;
}

.font-18 {
    font-size: 18px;
}

.font-20 {
    font-size: 20px;
}

.font-24 {
    font-size: 24px;
}

.font-30 {
    font-size: 30px;
}

.thumb-sm {
    height: 32px;
    width: 32px;
}

.thumb-md {
    height: 48px;
    width: 48px;
}

.thumb-lg {
    height: 88px;
    width: 88px;
}

.font-500 {
    font-weight: 500;
}

.font-600 {
    font-weight: 600;
}

.font-700 {
    font-weight: 700;
}

.header-title {
    font-size: 16px;
}

.profile-dropdown {
    width: 170px;
}

.profile-dropdown i {
    font-size: 17px;
    vertical-align: middle;
    margin-right: 5px;
    color: #adb5bd;
}

.nav-user img {
    height: 36px;
    width: 36px;
}

.arrow-none:after {
    border: none;
    margin: 0;
    display: none;
}

.dropdown-menu-lg {
    width: 300px;
}

.page-title-box {
    padding: 20px 0px;
}

.page-title-box .page-title {
    font-size: 20px;
    margin: 0;
    line-height: 30px;
    color: #333333;
    padding-top: 5px;
}

.page-title-box .state-information .state-graph {
    float: right;
    margin-left: 40px;
    text-align: center;
}

.page-title-box .state-information .state-graph .info {
    font-size: 12px;
    margin-top: 5px;
}

.page-title-box-dark {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    color: #2a3142;
    background-size: inherit;
}

.page-title-box-dark .breadcrumb a {
    color: rgba(42, 49, 66, 0.9);
}

.page-title-box-dark .breadcrumb a:hover {
    color: #2a3142;
}

.page-title-box-dark .breadcrumb .active {
    color: rgba(42, 49, 66, 0.5);
}

.page-title-box-dark .breadcrumb-item+.breadcrumb-item::before {
    color: rgba(42, 49, 66, 0.5);
}


button:focus {
    outline: none;
}

.btn-sm {
    font-size: 12.27273px;
}

.btn-lg {
    font-size: 16.2px;
}

.btn-primary,
.btn-success,
.btn-info,
.btn-warning,
.btn-danger,
.btn-dark,
.btn-pink,
.btn-purple,
.btn-indigo,
.btn-teal,
.btn-lime,
.btn-orange,
.btn-brown,
.btn-blue-grey {
    color: #ffffff;
}

.btn-primary {
    background-color: #1b82ec;
    border: 1px solid #1b82ec;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.btn-primary.focus,
.btn-primary:active,
.btn-primary:focus,
.btn-primary:hover,
.open>.dropdown-toggle.btn-primary,
.btn-outline-primary.active,
.btn-outline-primary:active,
.show>.btn-outline-primary.dropdown-toggle,
.btn-outline-primary:hover,
.btn-primary.active,
.btn-primary:active,
.show>.btn-primary.dropdown-toggle,
.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show>.btn-primary.dropdown-toggle {
    background-color: #1275db;
    border: 1px solid #1275db;
}

.btn-primary.focus,
.btn-primary:focus,
.btn-outline-primary.focus,
.btn-outline-primary:focus,
.btn-primary:not(:disabled):not(.disabled).active:focus,
.btn-primary:not(:disabled):not(.disabled):active:focus,
.show>.btn-primary.dropdown-toggle:focus {
    -webkit-box-shadow: 0 0 0 2px rgba(27, 130, 236, 0.3);
    box-shadow: 0 0 0 2px rgba(27, 130, 236, 0.3);
}

.btn-secondary.focus,
.btn-secondary:focus,
.btn-outline-secondary.focus,
.btn-outline-secondary:focus,
.btn-secondary:not(:disabled):not(.disabled).active:focus,
.btn-secondary:not(:disabled):not(.disabled):active:focus,
.show>.btn-secondary.dropdown-toggle:focus {
    -webkit-box-shadow: 0 0 0 2px rgba(42, 49, 66, 0.3);
    box-shadow: 0 0 0 2px rgba(42, 49, 66, 0.3);
}

.btn-success {
    background-color: #35a989;
    border: 1px solid #35a989;
}

.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success.active,
.btn-success.focus,
.btn-success:active,
.btn-success:focus,
.btn-success:hover,
.open>.dropdown-toggle.btn-success,
.btn-outline-success.active,
.btn-outline-success:active,
.show>.btn-outline-success.dropdown-toggle,
.btn-outline-success:hover,
.btn-success.active,
.btn-success:active,
.show>.btn-success.dropdown-toggle,
.btn-success:not(:disabled):not(.disabled).active:focus,
.btn-success:not(:disabled):not(.disabled):active:focus,
.show>.btn-success.dropdown-toggle:focus {
    background-color: #2f9679;
    border: 1px solid #2f9679;
}

.btn-success.focus,
.btn-success:focus,
.btn-outline-success.focus,
.btn-outline-success:focus,
.btn-success:not(:disabled):not(.disabled).active:focus,
.btn-success:not(:disabled):not(.disabled):active:focus,
.show>.btn-success.dropdown-toggle:focus {
    -webkit-box-shadow: 0 0 0 2px rgba(53, 169, 137, 0.3);
    box-shadow: 0 0 0 2px rgba(53, 169, 137, 0.3);
}

.btn-info {
    background-color: #29bbe3;
    border: 1px solid #29bbe3;
}

.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-info.active,
.btn-info.focus,
.btn-info:active,
.btn-info:focus,
.btn-info:hover,
.open>.dropdown-toggle.btn-info,
.btn-outline-info.active,
.btn-outline-info:active,
.show>.btn-outline-info.dropdown-toggle,
.btn-outline-info:hover,
.btn-info.active,
.btn-info:active,
.show>.btn-info.dropdown-toggle,
.btn-info:not(:disabled):not(.disabled).active,
.btn-info:not(:disabled):not(.disabled):active,
.show>.btn-info.dropdown-toggle {
    background-color: #1caed6;
    border: 1px solid #1caed6;
}

.btn-info.focus,
.btn-info:focus,
.btn-outline-info.focus,
.btn-outline-info:focus,
.btn-info:not(:disabled):not(.disabled).active:focus,
.btn-info:not(:disabled):not(.disabled):active:focus,
.show>.btn-info.dropdown-toggle:focus {
    -webkit-box-shadow: 0 0 0 2px rgba(41, 187, 227, 0.3);
    box-shadow: 0 0 0 2px rgba(41, 187, 227, 0.3);
}

.btn-warning {
    background-color: #f5b225;
    border: 1px solid #f5b225;
}

.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active,
.btn-warning.active,
.btn-warning.focus,
.btn-warning:active,
.btn-warning:focus,
.btn-warning:hover,
.open>.dropdown-toggle.btn-warning,
.btn-outline-warning.active,
.btn-outline-warning:active,
.show>.btn-outline-warning.dropdown-toggle,
.btn-outline-warning:hover,
.btn-warning.active,
.btn-warning:active,
.show>.btn-warning.dropdown-toggle,
.btn-warning:not(:disabled):not(.disabled).active,
.btn-warning:not(:disabled):not(.disabled):active,
.show>.btn-warning.dropdown-toggle {
    background-color: #f4a90d;
    border: 1px solid #f4a90d;
    color: #ffffff;
}

.btn-warning.focus,
.btn-warning:focus,
.btn-outline-warning.focus,
.btn-outline-warning:focus,
.btn-warning:not(:disabled):not(.disabled).active:focus,
.btn-warning:not(:disabled):not(.disabled):active:focus,
.show>.btn-warning.dropdown-toggle:focus {
    -webkit-box-shadow: 0 0 0 2px rgba(245, 178, 37, 0.3);
    box-shadow: 0 0 0 2px rgba(245, 178, 37, 0.3);
}

.btn-danger {
    background-color: #f16c69;
    border: 1px solid #f16c69;
}

.btn-danger:active,
.btn-danger:focus,
.btn-danger:hover,
.btn-danger.active,
.btn-danger.focus,
.btn-danger:active,
.btn-danger:focus,
.btn-danger:hover,
.open>.dropdown-toggle.btn-danger,
.btn-outline-danger.active,
.btn-outline-danger:active,
.show>.btn-outline-danger.dropdown-toggle,
.btn-outline-danger:hover,
.btn-danger.active,
.btn-danger:active,
.show>.btn-danger.dropdown-toggle,
.btn-danger:not(:disabled):not(.disabled).active,
.btn-danger:not(:disabled):not(.disabled):active,
.show>.btn-danger.dropdown-toggle {
    background-color: #ef5552;
    border: 1px solid #ef5552;
}

.btn-danger.focus,
.btn-danger:focus,
.btn-outline-danger.focus,
.btn-outline-danger:focus,
.btn-danger:not(:disabled):not(.disabled).active:focus,
.btn-danger:not(:disabled):not(.disabled):active:focus,
.show>.btn-danger.dropdown-toggle:focus {
    -webkit-box-shadow: 0 0 0 2px rgba(241, 108, 105, 0.3);
    box-shadow: 0 0 0 2px rgba(241, 108, 105, 0.3);
}

.btn-dark {
    background-color: #2a3142;
    border: 1px solid #2a3142;
    color: #ffffff;
}

.btn-dark:hover,
.btn-dark:focus,
.btn-dark:active,
.btn-dark.active,
.btn-dark.focus,
.btn-dark:active,
.btn-dark:focus,
.btn-dark:hover,
.open>.dropdown-toggle.btn-dark,
.btn-outline-dark.active,
.btn-outline-dark:active,
.show>.btn-outline-dark.dropdown-toggle,
.btn-outline-dark:hover {
    background-color: #202532;
    border: 1px solid #202532;
    color: #ffffff;
}

.btn-dark.focus,
.btn-dark:focus,
.btn-outline-dark.focus,
.btn-outline-dark:focus {
    -webkit-box-shadow: 0 0 0 2px rgba(42, 49, 66, 0.3);
    box-shadow: 0 0 0 2px rgba(42, 49, 66, 0.3);
}

.btn-link {
    color: #2a3142;
}

.btn-link:hover {
    color: #1b82ec;
}

.btn-outline-primary {
    color: #1b82ec;
    border-color: #1b82ec;
}

.btn-outline-success {
    color: #35a989;
    border-color: #35a989;
}

.btn-outline-info {
    color: #29bbe3;
    border-color: #29bbe3;
}

.btn-outline-warning {
    color: #f5b225;
    border-color: #f5b225;
}

.btn-outline-danger {
    color: #f16c69;
    border-color: #f16c69;
}

.btn-outline-dark {
    color: #2a3142;
    background-image: none;
    background-color: transparent;
    border-color: #2a3142;
}

.alert {
    position: relative;
    border: 0;
    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
}

.alert .alert-link {
    font-weight: 500;
}



.alert-success hr {
    border-top-color: #29826a;
}

.alert-info {
    color: #29bbe3;
    background-color: #c7edf8;
}

.alert-info .alert-link {
    color: #199cc0;
}

.alert-info hr {
    border-top-color: #199cc0;
}

.alert-warning {
    color: #f5b225;
    background-color: #fce9c1;
}

.alert-warning .alert-link {
    color: #dd990a;
}

.alert-warning hr {
    border-top-color: #dd990a;
}

.alert-danger {
    color: #f16c69;
    background-color: #fef5f5;
}

.alert-danger .alert-link {
    color: #ed3e3a;
}

.alert-danger hr {
    border-top-color: #ed3e3a;
}

.alert-primary {
    color: #1b82ec;
    background-color: #8cc0f5;
}

.alert-primary .alert-link {
    color: #1069c4;
}

.alert-primary hr {
    border-top-color: #1069c4;
}

.chart {
    position: relative;
    display: inline-block;
    width: 110px;
    height: 110px;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
}

.chart canvas {
    position: absolute;
    top: 0;
    left: 0;
}

.chart.chart-widget-pie {
    margin-top: 5px;
    margin-bottom: 5px;
}

.percent {
    display: inline-block;
    line-height: 110px;
    z-index: 2;
}

.percent:after {
    content: "%";
    margin-left: 0.1em;
    font-size: 0.8em;
}

.morris-charts text {
 
}

.morris-chart-height {
    height: 300px;
}

.morris-hover.morris-default-style {
    border-radius: 5px;
    padding: 10px 12px;
    background: #ffffff;
    border: none;
    -webkit-box-shadow: 0 5px 25px 5px rgba(0, 0, 0, 0.14);
    box-shadow: 0 5px 25px 5px rgba(0, 0, 0, 0.14);
}

.morris-hover.morris-default-style .morris-hover-point {
    font-weight: 500;
    font-size: 13.5px;
    color: #2a3142 !important;
    
}

.morris-hover.morris-default-style .morris-hover-row-label {
    background-color: #2a3142;
    color: #ffffff;
    padding: 4px;
    border-radius: 5px 5px 0 0;
    margin: -10px -12px 10px;
    
}

.flot-chart-height {
    height: 320px;
}

#flotTip {
    padding: 8px 12px;
    background-color: #ffffff;
    z-index: 100;
    color: #2a3142;
    -webkit-box-shadow: 0 5px 25px 5px rgba(0, 0, 0, 0.14);
    box-shadow: 0 5px 25px 5px rgba(0, 0, 0, 0.14);
    border-radius: 1px;
}

.ct-golden-section:before {
    float: none;
}

.ct-chart {
    height: 300px;
}

.ct-grid {
    stroke: rgba(0, 0, 0, 0.09);
    stroke-width: 2px;
    stroke-dasharray: 3px;
}

.ct-chart .ct-label {
    fill: #949a9e;
    color: #949a9e;
    font-size: 10px;
    line-height: 1;
}

.ct-chart.simple-pie-chart-chartist .ct-label {
    color: #ffffff;
    fill: #ffffff;
    font-size: 16px;
}

.ct-chart .ct-series.ct-series-a .ct-bar,
.ct-chart .ct-series.ct-series-a .ct-line,
.ct-chart .ct-series.ct-series-a .ct-point,
.ct-chart .ct-series.ct-series-a .ct-slice-donut {
    stroke: #1b82ec;
}

.ct-chart .ct-series.ct-series-b .ct-bar,
.ct-chart .ct-series.ct-series-b .ct-line,
.ct-chart .ct-series.ct-series-b .ct-point,
.ct-chart .ct-series.ct-series-b .ct-slice-donut {
    stroke: #29bbe3;
}

.ct-chart .ct-series.ct-series-c .ct-bar,
.ct-chart .ct-series.ct-series-c .ct-line,
.ct-chart .ct-series.ct-series-c .ct-point,
.ct-chart .ct-series.ct-series-c .ct-slice-donut {
    stroke: #f5b225;
}

.ct-chart .ct-series.ct-series-d .ct-bar,
.ct-chart .ct-series.ct-series-d .ct-line,
.ct-chart .ct-series.ct-series-d .ct-point,
.ct-chart .ct-series.ct-series-d .ct-slice-donut {
    stroke: #2a3142;
}

.ct-chart .ct-series.ct-series-e .ct-bar,
.ct-chart .ct-series.ct-series-e .ct-line,
.ct-chart .ct-series.ct-series-e .ct-point,
.ct-chart .ct-series.ct-series-e .ct-slice-donut {
    stroke: #35a989;
}

.ct-chart .ct-series.ct-series-f .ct-bar,
.ct-chart .ct-series.ct-series-f .ct-line,
.ct-chart .ct-series.ct-series-f .ct-point,
.ct-chart .ct-series.ct-series-f .ct-slice-donut {
    stroke: #f16c69;
}

.ct-chart .ct-series.ct-series-g .ct-bar,
.ct-chart .ct-series.ct-series-g .ct-line,
.ct-chart .ct-series.ct-series-g .ct-point,
.ct-chart .ct-series.ct-series-g .ct-slice-donut {
    stroke: #f9f9f9;
}

.ct-series-a .ct-area,
.ct-series-a .ct-slice-pie {
    fill: #1b82ec;
}

.ct-series-b .ct-area,
.ct-series-b .ct-slice-pie {
    fill: #f5b225;
}

.ct-series-c .ct-area,
.ct-series-c .ct-slice-pie {
    fill: #2a3142;
}

.chartist-tooltip {
    position: absolute;
    display: inline-block;
    opacity: 0;
    min-width: 10px;
    padding: 2px 10px;
    border-radius: 3px;
    -moz-border-radius: 3px;
    background-clip: padding-box;
    background: #2a3142;
    color: #ffffff;
    text-align: center;
    pointer-events: none;
    z-index: 1;
    -webkit-transition: opacity 0.2s linear;
    transition: opacity 0.2s linear;
}

.chartist-tooltip.tooltip-show {
    opacity: 1;
}

.c3 svg {
    max-width: 100%;
}

.c3-tooltip td>span {
    background: #2a3142;
}

.c3-tooltip td {
    border-left: none;
}

.c3-tooltip {
    -webkit-box-shadow: 0 8px 40px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 8px 40px 0 rgba(0, 0, 0, 0.12);
    opacity: 1;
}

.c3-chart-arcs-title {
    font-size: 18px;
    font-weight: 600;
}

.c3-tooltip tr {
    border: none !important;
}

.c3-tooltip th {
    background-color: #2a3142;
}

.c3-tooltip .value {
    font-weight: 600;
}

.c3-line {
    stroke-width: 2px;
}

.c3-legend-item {
    font-size: 13px;
}

.jqstooltip {
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    background-color: #ffffff !important;
    padding: 5px 10px !important;
    border-radius: 3px;
    border-color: #ffffff !important;
    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
}

.jqsfield {
    font-size: 12px !important;
    line-height: 18px !important;
    color: #2a3142 !important;
}

.widget-chart li {
    width: 31.5%;
    display: inline-block;
    padding: 0;
}

.widget-chart li i {
    font-size: 22px;
}

.mini-stat {
    overflow: hidden;
}

.mini-stat .mini-stat-desc .verti-label {
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
    position: absolute;
    top: 44px;
    right: -9px;
    letter-spacing: 2px;
}

.mini-stat .mini-stat-icon i {
    position: absolute;
    right: 46px;
    top: -35px;
    color: rgba(255, 255, 255, 0.3);
}

.recent-activity-tab .nav-item {
    position: relative;
    padding-top: 30px;
    border-top: 2px solid #e9ecef;
}

.recent-activity-tab .nav-item::before {
    content: "";
    position: absolute;
    top: -7px;
    width: 12px;
    height: 12px;
    background: #1b82ec;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.4);
}

.recent-activity-tab .nav-item .nav-link {
    color: #2a3142;
    border-radius: 30px;
    position: relative;
}

.recent-activity-tab .nav-item .nav-link.active {
    color: #ffffff;
}

.recent-activity-tab .nav-item .nav-link.active:before {
    content: "";
    position: absolute;
    width: 20px;
    height: 16px;
    background: #1b82ec;
    -webkit-transform: rotate(-60deg) skew(60deg);
    transform: rotate(-60deg) skew(60deg);
    top: -7px;
}

@media (max-width: 420px) {
    .recent-activity-tab .nav-item .nav-link.active:before {
        left: 12px;
    }
}

.inbox-wid .inbox-item {
    position: relative;
    border-bottom: 1px solid rgba(243, 243, 243, 0.9);
    overflow: hidden;
    padding: 10px 0;
}

.inbox-wid .inbox-item .inbox-item-date {
    font-size: 11px;
    position: absolute;
    right: 7px;
    top: 8px;
}

.order-table .badge {
    padding: 0.5em 0.6em;
    text-transform: uppercase;
}

.order-table .badge-primary {
    background: rgba(27, 130, 236, 0.5);
}

.order-table .badge-success {
    background: rgba(53, 169, 137, 0.5);
}

.order-table .badge-warning {
    background: rgba(245, 178, 37, 0.5);
}

.dashboard-charts {
    height: 300px;
}

.dashboard-ds .table-hover tbody tr:hover,
.dashboard-ds .table-striped tbody tr:nth-of-type(odd),
.dashboard-ds .thead-default th {
    background-color: #f9f9f9;
}

.dashboard-ds .card {
    border: none;
    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
    margin-bottom: 30px;
}

h1.logoheading {
    font-size: 20px;
    color: #fff;
    padding-top: 9px;
}

.row-tails {
    display: flex;
    width: 100%;
    background: #ffffff;
    border-radius: 6px;
}

.row-tails .mini-stat-icon {
    color: #1b82ec;
    width: 70px;
    height: 70px;
    background: #f0f7ff;
    border-radius: 5px;
    padding: 15px;
    display: flex;
    justify-content: center;
    margin-right: 10px;
}

.row-tails .mini-stat-desc {
    display: flex;
    justify-content: center;
    align-items: center;
}

.row-tails .mini-stat-desc h3 {
    font-weight: 600;
    font-size: 22px;
}

.row-tails .mini-stat-desc h6 {
    font-size: 13px;
    color: #bbbbbb;
    font-weight: 400;
}

.row-tails .mini-stat-desc h5 {
    font-size: 13px;
    margin-top: 0;
    margin-bottom: 25px;
    margin-left: 30px;
}

.row-tails .mini-stat-desc h5 i {
    font-weight: 700;
}

.row-tails .card-body {
    display: flex;
    position: relative;
    width: 20%;
    padding: 15px;
}

.row-tails .card-body:after {
    content: "";
    position: absolute;
    width: 2px;
    height: 60%;
    top: 20%;
    background: #eaeaea;
    right: 0px;
}

.row-tails .card-body:last-child:after {
    background: #ffffff;
}

ul.chart-ul {
    display: flex;
    justify-content: space-between;
    padding: 0px;
    margin: 0px;
    list-style-type: none;
}

ul.chart-ul li p {
    font-size: 14px;
    color: #bbbbbb;
    font-weight: 400;
    margin-bottom: 0;
}

ul.chart-ul li p i {
    font-size: 10px;
    padding-right: 3px;
    color: #1b82ec;
}

ul.chart-ul li p:nth-child(2) i {
    color: #29bbe3;
}

ul.chart-ul li p:nth-child(3) i {
    color: #f5b225;
}

ul.chart-ul li h5 {
    font-size: 13px;
    margin-top: 0;
    margin-bottom: 25px;
    margin-left: 30px;
}

.chart-row .header-title {
    font-size: 16px;
    border-bottom: 1px solid #ece9e9;
    padding-bottom: 10px;
}

.credit-card img.d-block.img-fluid {
    width: 300px;
    height: 200px;
}

ul.credit-card-ul {
    padding: 0px;
    margin: 0px;
    list-style-type: none;
}

ul.credit-card-ul li {
    display: flex;
    justify-content: space-between;
    height: 75px;
    align-items: center;
    border-bottom: 1px solid #ece9e9;
}

ul.credit-card-ul li:last-child {
    border: 0px;
}

ul.credit-card-ul li .pic {
    width: 85px;
    background: #f3f3f3;
    height: 55px;
    padding: 20px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
}

ul.credit-card-ul li .pic img {
    width: 100%;
}

ul.credit-card-ul li h1 {
    color: #0d2f52;
    font-size: 20px;
    margin: 0px;
}

ul.credit-card-ul li .details {
    display: flex;
    align-items: center;
}

ul.credit-card-ul li p {
    margin: 0px;
    font-size: 14px;
    color: #bbbbbb;
    font-weight: 400;
}

ul.credit-card-ul li .rate {
    min-width: 100px;
}

ul.credit-card-ul li .rate h1 i {
    float: right;
    font-weight: 700;
}

.chart-row.credit-card .carousel {
    position: relative;
    padding-bottom: 62px;
    padding-top: 30px;
}

.chart-row.credit-card .carousel-indicators li {
    width: 8px;
    height: 8px;
    background-color: #cccccc;
    border-radius: 50%;
}

.chart-row.credit-card .carousel-indicators .active {
    background-color: #f5b225;
}

.chart-row.credit-card .carousel-control-next,
.chart-row.credit-card .carousel-control-prev {
    bottom: 25px;
    top: auto;
    font-size: 20px;
    color: #424242;
}

.chart-row .card {
    border-radius: 7px;
}

.chart-row table th {
    font-weight: 600;
    color: #000;
}

.table-responsive.ct-chart {
    margin-top: 25px;
    display: flex;
    align-items: center;
    height: auto;
}

.table-view .heading {
    display: flex;
    border: 1px solid #d2d2d2;
    margin-top: 15px;
}

.heading .item {
    width: 50%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 17px;
    background: #ffffff;
    color: #333333;
    padding: 5px 5px;
    border-right: 2px solid #cecece;
}

.heading .item:last-child {
    border: 0px;
}

.table-view .heading2 {
    display: flex;
    border: 1px solid #dadada;
}

.heading2 .item {
    width: 50%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    border-right: 2px solid #dadada;
}

.heading2 .item:last-child {
    border: 0px;
}

.heading2 .item .box {
    width: 25%;
    border-right: 2px solid #dadada;
}

.heading2 .item .box:last-child {
    border: 0px;
}

.heading2 .item:last-child {
    border: 0px;
}

.heading2 .item .item2 {
    font-size: 15px;
    line-height: 19px;
    text-align: center;
    padding: 7px 5px;
    background: #f1f1f1;
    height: 52px;
    display: flex;
    align-items: center;
}

.heading2 .item .box span {
    display: block;
    padding: 7px 5px;
    font-size: 17px;
    color: #333333;
}

.heading2 .item .item2:last-child {
    border: 0px;
}

.table-responsive.ct-chart.table2 {
    margin-top: 25px;
    display: flex;
    align-items: center;
    height: auto;
}

@media (max-width: 1199px) {
    .row-tails .mini-stat-icon {
        width: 60px;
        height: 60px;
        padding: 13px;
        margin-right: 10px;
    }

    .row-tails .mini-stat-desc h3 {
        font-size: 20px;
    }

    .row-tails .card-body {
        padding: 10px;
    }

    .row-tails .mini-stat-desc h6 {
        font-size: 11px;
    }

    ul.chart-ul li h3 {
        font-size: 25px;
    }

    ul.chart-ul li p {
        font-size: 13px;
    }

    ul.credit-card-ul li {
        height: 66px;
    }

    ul.credit-card-ul li .pic {
        width: 80px;
        height: 50px;
        padding: 18px;
        margin-right: 18px;
    }

    ul.credit-card-ul li h1 {
        font-size: 17px;
    }

    ul.credit-card-ul li p {
        font-size: 13px;
    }

    .credit-card img.d-block.img-fluid {
        height: 165px;
    }
}

@media (max-width: 991px) {
    .chart-row.chart-box .col-xl-4.col-md-4 {
        max-width: inherit;
        flex: auto;
        width: 100%;
    }

    .row-tails .mini-stat-desc h5 {
        font-size: 10px;
        margin-left: 15px;
    }

    .row-tails .mini-stat-icon {
        width: 45px;
        height: 45px;
        padding: 10px;
        margin-right: 12px;
    }

    .row-tails .mini-stat-desc h3 {
        font-size: 15px;
    }

    .row-tails .mini-stat-desc h6 {
        font-size: 10px;
    }

    ul.credit-card-ul li {
        height: 55px;
    }

    ul.credit-card-ul li .pic {
        width: 70px;
        height: 40px;
        padding: 15px;
        margin-right: 15px;
    }

    ul.credit-card-ul li h1 {
        font-size: 15px;
    }

    ul.credit-card-ul li p {
        font-size: 12px;
    }

    .credit-card img.d-block.img-fluid {
        height: 121px;
    }
}

@media (max-width: 767px) {
    .row-tails {
        flex-wrap: wrap;
    }

    .row-tails .card-body {
        width: 50%;
    }

    .row-tails .mini-stat-desc {
        width: 100%;
    }

    .row-tails .mini-stat-desc .text-white {
        width: calc(100% - 120px);
    }

    .row-tails .mini-stat-desc h5 {
        width: 75px;
        font-size: 13px;
    }

    .row-tails .mini-stat-icon {
        width: 75px;
        height: 60px;
        padding: 13px;
        margin-right: 15px;
    }

    .row-tails .mini-stat-desc h3 {
        font-size: 22px;
    }

    .row-tails .mini-stat-desc h6 {
        font-size: 14px;
    }

    .credit-card img.d-block.img-fluid {
        height: 165px;
    }

    ul.credit-card-ul li .rate {
        min-width: 75px;
    }

    ul.credit-card-ul li h1 {
        font-size: 14px;
    }

    .row-tails .card-body:nth-child(2)::after {
        display: none;
    }

    .row-tails .card-body:nth-child(4)::after {
        display: none;
    }
}

@media (max-width: 550px) {
    .row-tails {
        flex-direction: column;
    }

    .row-tails .card-body {
        width: 100%;
    }

    .row-tails .card-body:after {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./app/pages/Consultant/ConsultantDashboard/DashBoard.css"],"names":[],"mappings":"AAAA;;4EAE4E;;AAG5E;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;;IAEnB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX;qCACiC;IACjC,uEAAuE;IACvE,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,gBAAgB;IAChB,iDAAiD;IACjD,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;;;;AAKA;IACI;qCACiC;IACjC,uEAAuE;IACvE,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mDAA0D;IAC1D,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;;;;;;;;;;;;IAcI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;;;;;;;;;;;;;;;;;;IAmBI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;;;;;;IAOI,qDAAqD;IACrD,6CAA6C;AACjD;;AAEA;;;;;;;IAOI,mDAAmD;IACnD,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;;;;;;;;;;;;;;;;;;IAmBI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;;;;;;IAOI,qDAAqD;IACrD,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;;;;;;;;;;;;;;;;;;IAmBI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;;;;;;IAOI,qDAAqD;IACrD,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;;;;;;;;;;;;;;;;;;IAmBI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;;;;;IAOI,qDAAqD;IACrD,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;;;;;;;;;;;;;;;;;;IAmBI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;;;;;;IAOI,sDAAsD;IACtD,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;;;;;;;;;;;IAaI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;;IAII,mDAAmD;IACnD,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,iDAAiD;IACjD,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;AAEA;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,sDAAsD;IACtD,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,0BAA0B;IAC1B,wBAAwB;;AAE5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,sDAAsD;IACtD,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,eAAe;AACnB;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,4BAA4B;IAC5B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,uCAAuC;IACvC,+BAA+B;AACnC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oDAAoD;IACpD,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;IACvB,oCAAoC;IACpC,4BAA4B;IAC5B,kBAAkB;IAClB,gCAAgC;IAChC,iDAAiD;IACjD,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6CAA6C;IAC7C,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,iDAAiD;IACjD,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,iDAAiD;IACjD,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;IACZ,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,+BAA+B;AACnC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* =========================================================================\n                                TABLES OF CSS\n===========================================================================*/\n@import url(\"https://fonts.googleapis.com/css?family=Roboto:300,400,500,700\");\n\na:hover {\n    outline: 0;\n    text-decoration: none;\n}\n\na:active {\n    outline: 0;\n    text-decoration: none;\n}\n\na:focus {\n    outline: 0;\n    text-decoration: none;\n}\n\n.container-alt {\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 15px;\n    padding-right: 15px;\n}\n\n.dashboard-ds {\n    background: #f3f3f3;\n    \n    color: #5b626b;\n    font-size: 13.5px;\n}\n\n.slimScrollDiv {\n    height: auto !important;\n}\n\n.custom-checkbox .custom-control-input:checked~.custom-control-label::before {\n    background-color: #1b82ec;\n}\n\n.social-links li a {\n    border-radius: 50%;\n    display: inline-block;\n    height: 30px;\n    line-height: 30px;\n    width: 30px;\n    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1),\n        0 2px 5px rgba(0, 0, 0, 0.15);\n    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1), 0 2px 5px rgba(0, 0, 0, 0.15);\n    text-align: center;\n}\n\n.bg-primary {\n    background-color: #1b82ec !important;\n}\n\n.bg-success {\n    background-color: #35a989 !important;\n}\n\n.bg-info {\n    background-color: #29bbe3 !important;\n}\n\n.bg-warning {\n    background-color: #f5b225 !important;\n}\n\n.bg-danger {\n    background-color: #f16c69 !important;\n}\n\n.bg-muted {\n    background-color: #949a9e !important;\n}\n\n.bg-white {\n    background-color: #ffffff !important;\n}\n\n.text-white {\n    color: #ffffff !important;\n}\n\n.text-danger {\n    color: #f16c69 !important;\n}\n\n.text-muted {\n    color: #949a9e !important;\n}\n\n.text-primary {\n    color: #1b82ec !important;\n}\n\n.text-warning {\n    color: #f5b225 !important;\n}\n\n.text-success {\n    color: #35a989 !important;\n}\n\n.text-info {\n    color: #29bbe3 !important;\n}\n\n\n.badge {\n    font-weight: 500;\n    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);\n    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);\n}\n\n.badge-primary {\n    background-color: #1b82ec;\n}\n\n.badge-success {\n    background-color: #35a989;\n}\n\n.badge-info {\n    background-color: #29bbe3;\n}\n\n.badge-warning {\n    background-color: #f5b225;\n    color: white;\n}\n\n.badge-danger {\n    background-color: #f16c69;\n}\n\n.badge-dark {\n    background-color: #2a3142;\n}\n\ndt {\n    font-weight: 500;\n}\n\n\n\n\n.popover {\n    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1),\n        0 2px 5px rgba(0, 0, 0, 0.15);\n    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1), 0 2px 5px rgba(0, 0, 0, 0.15);\n    border: none;\n}\n\n.p-0 {\n    padding: 0;\n}\n\n.p-t-10 {\n    padding-top: 10px;\n}\n\n.p-b-10 {\n    padding-bottom: 10px;\n}\n\n.m-0 {\n    margin: 0;\n}\n\n.m-r-5 {\n    margin-right: 5px;\n}\n\n.m-r-10 {\n    margin-right: 10px;\n}\n\n.m-r-15 {\n    margin-right: 15px;\n}\n\n.m-l-10 {\n    margin-left: 10px;\n}\n\n.m-l-15 {\n    margin-left: 15px;\n}\n\n.m-t-5 {\n    margin-top: 5px;\n}\n\n.m-t-10 {\n    margin-top: 10px;\n}\n\n.m-t-15 {\n    margin-top: 15px;\n}\n\n.m-t-20 {\n    margin-top: 20px;\n}\n\n.m-t-30 {\n    margin-top: 30px;\n}\n\n.m-t-40 {\n    margin-top: 40px;\n}\n\n.m-b-2-force {\n    margin-bottom: 2px !important;\n}\n\n.m-b-5 {\n    margin-bottom: 5px;\n}\n\n.m-b-10 {\n    margin-bottom: 10px;\n}\n\n.m-b-15 {\n    margin-bottom: 15px;\n}\n\n.m-b-20 {\n    margin-bottom: 20px;\n}\n\n.m-b-30 {\n    margin-bottom: 30px;\n}\n\n.w-30 {\n    max-width: 30px;\n}\n\n.w-xs {\n    min-width: 80px;\n}\n\n.w-sm {\n    min-width: 95px;\n}\n\n.w-md {\n    min-width: 110px;\n}\n\n.w-lg {\n    min-width: 140px;\n}\n\n.l-h-23 {\n    line-height: 23px;\n}\n\n.l-h-34 {\n    line-height: 34px;\n}\n\n.font-12 {\n    font-size: 12px;\n}\n\n.font-14 {\n    font-size: 14px;\n}\n\n.font-16 {\n    font-size: 16px;\n}\n\n.font-18 {\n    font-size: 18px;\n}\n\n.font-20 {\n    font-size: 20px;\n}\n\n.font-24 {\n    font-size: 24px;\n}\n\n.font-30 {\n    font-size: 30px;\n}\n\n.thumb-sm {\n    height: 32px;\n    width: 32px;\n}\n\n.thumb-md {\n    height: 48px;\n    width: 48px;\n}\n\n.thumb-lg {\n    height: 88px;\n    width: 88px;\n}\n\n.font-500 {\n    font-weight: 500;\n}\n\n.font-600 {\n    font-weight: 600;\n}\n\n.font-700 {\n    font-weight: 700;\n}\n\n.header-title {\n    font-size: 16px;\n}\n\n.profile-dropdown {\n    width: 170px;\n}\n\n.profile-dropdown i {\n    font-size: 17px;\n    vertical-align: middle;\n    margin-right: 5px;\n    color: #adb5bd;\n}\n\n.nav-user img {\n    height: 36px;\n    width: 36px;\n}\n\n.arrow-none:after {\n    border: none;\n    margin: 0;\n    display: none;\n}\n\n.dropdown-menu-lg {\n    width: 300px;\n}\n\n.page-title-box {\n    padding: 20px 0px;\n}\n\n.page-title-box .page-title {\n    font-size: 20px;\n    margin: 0;\n    line-height: 30px;\n    color: #333333;\n    padding-top: 5px;\n}\n\n.page-title-box .state-information .state-graph {\n    float: right;\n    margin-left: 40px;\n    text-align: center;\n}\n\n.page-title-box .state-information .state-graph .info {\n    font-size: 12px;\n    margin-top: 5px;\n}\n\n.page-title-box-dark {\n    background: url(\"/public/assets/images/pattern-white.png\");\n    color: #2a3142;\n    background-size: inherit;\n}\n\n.page-title-box-dark .breadcrumb a {\n    color: rgba(42, 49, 66, 0.9);\n}\n\n.page-title-box-dark .breadcrumb a:hover {\n    color: #2a3142;\n}\n\n.page-title-box-dark .breadcrumb .active {\n    color: rgba(42, 49, 66, 0.5);\n}\n\n.page-title-box-dark .breadcrumb-item+.breadcrumb-item::before {\n    color: rgba(42, 49, 66, 0.5);\n}\n\n\nbutton:focus {\n    outline: none;\n}\n\n.btn-sm {\n    font-size: 12.27273px;\n}\n\n.btn-lg {\n    font-size: 16.2px;\n}\n\n.btn-primary,\n.btn-success,\n.btn-info,\n.btn-warning,\n.btn-danger,\n.btn-dark,\n.btn-pink,\n.btn-purple,\n.btn-indigo,\n.btn-teal,\n.btn-lime,\n.btn-orange,\n.btn-brown,\n.btn-blue-grey {\n    color: #ffffff;\n}\n\n.btn-primary {\n    background-color: #1b82ec;\n    border: 1px solid #1b82ec;\n}\n\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary:active,\n.btn-primary.active,\n.btn-primary.focus,\n.btn-primary:active,\n.btn-primary:focus,\n.btn-primary:hover,\n.open>.dropdown-toggle.btn-primary,\n.btn-outline-primary.active,\n.btn-outline-primary:active,\n.show>.btn-outline-primary.dropdown-toggle,\n.btn-outline-primary:hover,\n.btn-primary.active,\n.btn-primary:active,\n.show>.btn-primary.dropdown-toggle,\n.btn-primary:not(:disabled):not(.disabled).active,\n.btn-primary:not(:disabled):not(.disabled):active,\n.show>.btn-primary.dropdown-toggle {\n    background-color: #1275db;\n    border: 1px solid #1275db;\n}\n\n.btn-primary.focus,\n.btn-primary:focus,\n.btn-outline-primary.focus,\n.btn-outline-primary:focus,\n.btn-primary:not(:disabled):not(.disabled).active:focus,\n.btn-primary:not(:disabled):not(.disabled):active:focus,\n.show>.btn-primary.dropdown-toggle:focus {\n    -webkit-box-shadow: 0 0 0 2px rgba(27, 130, 236, 0.3);\n    box-shadow: 0 0 0 2px rgba(27, 130, 236, 0.3);\n}\n\n.btn-secondary.focus,\n.btn-secondary:focus,\n.btn-outline-secondary.focus,\n.btn-outline-secondary:focus,\n.btn-secondary:not(:disabled):not(.disabled).active:focus,\n.btn-secondary:not(:disabled):not(.disabled):active:focus,\n.show>.btn-secondary.dropdown-toggle:focus {\n    -webkit-box-shadow: 0 0 0 2px rgba(42, 49, 66, 0.3);\n    box-shadow: 0 0 0 2px rgba(42, 49, 66, 0.3);\n}\n\n.btn-success {\n    background-color: #35a989;\n    border: 1px solid #35a989;\n}\n\n.btn-success:hover,\n.btn-success:focus,\n.btn-success:active,\n.btn-success.active,\n.btn-success.focus,\n.btn-success:active,\n.btn-success:focus,\n.btn-success:hover,\n.open>.dropdown-toggle.btn-success,\n.btn-outline-success.active,\n.btn-outline-success:active,\n.show>.btn-outline-success.dropdown-toggle,\n.btn-outline-success:hover,\n.btn-success.active,\n.btn-success:active,\n.show>.btn-success.dropdown-toggle,\n.btn-success:not(:disabled):not(.disabled).active:focus,\n.btn-success:not(:disabled):not(.disabled):active:focus,\n.show>.btn-success.dropdown-toggle:focus {\n    background-color: #2f9679;\n    border: 1px solid #2f9679;\n}\n\n.btn-success.focus,\n.btn-success:focus,\n.btn-outline-success.focus,\n.btn-outline-success:focus,\n.btn-success:not(:disabled):not(.disabled).active:focus,\n.btn-success:not(:disabled):not(.disabled):active:focus,\n.show>.btn-success.dropdown-toggle:focus {\n    -webkit-box-shadow: 0 0 0 2px rgba(53, 169, 137, 0.3);\n    box-shadow: 0 0 0 2px rgba(53, 169, 137, 0.3);\n}\n\n.btn-info {\n    background-color: #29bbe3;\n    border: 1px solid #29bbe3;\n}\n\n.btn-info:hover,\n.btn-info:focus,\n.btn-info:active,\n.btn-info.active,\n.btn-info.focus,\n.btn-info:active,\n.btn-info:focus,\n.btn-info:hover,\n.open>.dropdown-toggle.btn-info,\n.btn-outline-info.active,\n.btn-outline-info:active,\n.show>.btn-outline-info.dropdown-toggle,\n.btn-outline-info:hover,\n.btn-info.active,\n.btn-info:active,\n.show>.btn-info.dropdown-toggle,\n.btn-info:not(:disabled):not(.disabled).active,\n.btn-info:not(:disabled):not(.disabled):active,\n.show>.btn-info.dropdown-toggle {\n    background-color: #1caed6;\n    border: 1px solid #1caed6;\n}\n\n.btn-info.focus,\n.btn-info:focus,\n.btn-outline-info.focus,\n.btn-outline-info:focus,\n.btn-info:not(:disabled):not(.disabled).active:focus,\n.btn-info:not(:disabled):not(.disabled):active:focus,\n.show>.btn-info.dropdown-toggle:focus {\n    -webkit-box-shadow: 0 0 0 2px rgba(41, 187, 227, 0.3);\n    box-shadow: 0 0 0 2px rgba(41, 187, 227, 0.3);\n}\n\n.btn-warning {\n    background-color: #f5b225;\n    border: 1px solid #f5b225;\n}\n\n.btn-warning:hover,\n.btn-warning:focus,\n.btn-warning:active,\n.btn-warning.active,\n.btn-warning.focus,\n.btn-warning:active,\n.btn-warning:focus,\n.btn-warning:hover,\n.open>.dropdown-toggle.btn-warning,\n.btn-outline-warning.active,\n.btn-outline-warning:active,\n.show>.btn-outline-warning.dropdown-toggle,\n.btn-outline-warning:hover,\n.btn-warning.active,\n.btn-warning:active,\n.show>.btn-warning.dropdown-toggle,\n.btn-warning:not(:disabled):not(.disabled).active,\n.btn-warning:not(:disabled):not(.disabled):active,\n.show>.btn-warning.dropdown-toggle {\n    background-color: #f4a90d;\n    border: 1px solid #f4a90d;\n    color: #ffffff;\n}\n\n.btn-warning.focus,\n.btn-warning:focus,\n.btn-outline-warning.focus,\n.btn-outline-warning:focus,\n.btn-warning:not(:disabled):not(.disabled).active:focus,\n.btn-warning:not(:disabled):not(.disabled):active:focus,\n.show>.btn-warning.dropdown-toggle:focus {\n    -webkit-box-shadow: 0 0 0 2px rgba(245, 178, 37, 0.3);\n    box-shadow: 0 0 0 2px rgba(245, 178, 37, 0.3);\n}\n\n.btn-danger {\n    background-color: #f16c69;\n    border: 1px solid #f16c69;\n}\n\n.btn-danger:active,\n.btn-danger:focus,\n.btn-danger:hover,\n.btn-danger.active,\n.btn-danger.focus,\n.btn-danger:active,\n.btn-danger:focus,\n.btn-danger:hover,\n.open>.dropdown-toggle.btn-danger,\n.btn-outline-danger.active,\n.btn-outline-danger:active,\n.show>.btn-outline-danger.dropdown-toggle,\n.btn-outline-danger:hover,\n.btn-danger.active,\n.btn-danger:active,\n.show>.btn-danger.dropdown-toggle,\n.btn-danger:not(:disabled):not(.disabled).active,\n.btn-danger:not(:disabled):not(.disabled):active,\n.show>.btn-danger.dropdown-toggle {\n    background-color: #ef5552;\n    border: 1px solid #ef5552;\n}\n\n.btn-danger.focus,\n.btn-danger:focus,\n.btn-outline-danger.focus,\n.btn-outline-danger:focus,\n.btn-danger:not(:disabled):not(.disabled).active:focus,\n.btn-danger:not(:disabled):not(.disabled):active:focus,\n.show>.btn-danger.dropdown-toggle:focus {\n    -webkit-box-shadow: 0 0 0 2px rgba(241, 108, 105, 0.3);\n    box-shadow: 0 0 0 2px rgba(241, 108, 105, 0.3);\n}\n\n.btn-dark {\n    background-color: #2a3142;\n    border: 1px solid #2a3142;\n    color: #ffffff;\n}\n\n.btn-dark:hover,\n.btn-dark:focus,\n.btn-dark:active,\n.btn-dark.active,\n.btn-dark.focus,\n.btn-dark:active,\n.btn-dark:focus,\n.btn-dark:hover,\n.open>.dropdown-toggle.btn-dark,\n.btn-outline-dark.active,\n.btn-outline-dark:active,\n.show>.btn-outline-dark.dropdown-toggle,\n.btn-outline-dark:hover {\n    background-color: #202532;\n    border: 1px solid #202532;\n    color: #ffffff;\n}\n\n.btn-dark.focus,\n.btn-dark:focus,\n.btn-outline-dark.focus,\n.btn-outline-dark:focus {\n    -webkit-box-shadow: 0 0 0 2px rgba(42, 49, 66, 0.3);\n    box-shadow: 0 0 0 2px rgba(42, 49, 66, 0.3);\n}\n\n.btn-link {\n    color: #2a3142;\n}\n\n.btn-link:hover {\n    color: #1b82ec;\n}\n\n.btn-outline-primary {\n    color: #1b82ec;\n    border-color: #1b82ec;\n}\n\n.btn-outline-success {\n    color: #35a989;\n    border-color: #35a989;\n}\n\n.btn-outline-info {\n    color: #29bbe3;\n    border-color: #29bbe3;\n}\n\n.btn-outline-warning {\n    color: #f5b225;\n    border-color: #f5b225;\n}\n\n.btn-outline-danger {\n    color: #f16c69;\n    border-color: #f16c69;\n}\n\n.btn-outline-dark {\n    color: #2a3142;\n    background-image: none;\n    background-color: transparent;\n    border-color: #2a3142;\n}\n\n.alert {\n    position: relative;\n    border: 0;\n    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);\n    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);\n}\n\n.alert .alert-link {\n    font-weight: 500;\n}\n\n\n\n.alert-success hr {\n    border-top-color: #29826a;\n}\n\n.alert-info {\n    color: #29bbe3;\n    background-color: #c7edf8;\n}\n\n.alert-info .alert-link {\n    color: #199cc0;\n}\n\n.alert-info hr {\n    border-top-color: #199cc0;\n}\n\n.alert-warning {\n    color: #f5b225;\n    background-color: #fce9c1;\n}\n\n.alert-warning .alert-link {\n    color: #dd990a;\n}\n\n.alert-warning hr {\n    border-top-color: #dd990a;\n}\n\n.alert-danger {\n    color: #f16c69;\n    background-color: #fef5f5;\n}\n\n.alert-danger .alert-link {\n    color: #ed3e3a;\n}\n\n.alert-danger hr {\n    border-top-color: #ed3e3a;\n}\n\n.alert-primary {\n    color: #1b82ec;\n    background-color: #8cc0f5;\n}\n\n.alert-primary .alert-link {\n    color: #1069c4;\n}\n\n.alert-primary hr {\n    border-top-color: #1069c4;\n}\n\n.chart {\n    position: relative;\n    display: inline-block;\n    width: 110px;\n    height: 110px;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n.chart canvas {\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.chart.chart-widget-pie {\n    margin-top: 5px;\n    margin-bottom: 5px;\n}\n\n.percent {\n    display: inline-block;\n    line-height: 110px;\n    z-index: 2;\n}\n\n.percent:after {\n    content: \"%\";\n    margin-left: 0.1em;\n    font-size: 0.8em;\n}\n\n.morris-charts text {\n \n}\n\n.morris-chart-height {\n    height: 300px;\n}\n\n.morris-hover.morris-default-style {\n    border-radius: 5px;\n    padding: 10px 12px;\n    background: #ffffff;\n    border: none;\n    -webkit-box-shadow: 0 5px 25px 5px rgba(0, 0, 0, 0.14);\n    box-shadow: 0 5px 25px 5px rgba(0, 0, 0, 0.14);\n}\n\n.morris-hover.morris-default-style .morris-hover-point {\n    font-weight: 500;\n    font-size: 13.5px;\n    color: #2a3142 !important;\n    \n}\n\n.morris-hover.morris-default-style .morris-hover-row-label {\n    background-color: #2a3142;\n    color: #ffffff;\n    padding: 4px;\n    border-radius: 5px 5px 0 0;\n    margin: -10px -12px 10px;\n    \n}\n\n.flot-chart-height {\n    height: 320px;\n}\n\n#flotTip {\n    padding: 8px 12px;\n    background-color: #ffffff;\n    z-index: 100;\n    color: #2a3142;\n    -webkit-box-shadow: 0 5px 25px 5px rgba(0, 0, 0, 0.14);\n    box-shadow: 0 5px 25px 5px rgba(0, 0, 0, 0.14);\n    border-radius: 1px;\n}\n\n.ct-golden-section:before {\n    float: none;\n}\n\n.ct-chart {\n    height: 300px;\n}\n\n.ct-grid {\n    stroke: rgba(0, 0, 0, 0.09);\n    stroke-width: 2px;\n    stroke-dasharray: 3px;\n}\n\n.ct-chart .ct-label {\n    fill: #949a9e;\n    color: #949a9e;\n    font-size: 10px;\n    line-height: 1;\n}\n\n.ct-chart.simple-pie-chart-chartist .ct-label {\n    color: #ffffff;\n    fill: #ffffff;\n    font-size: 16px;\n}\n\n.ct-chart .ct-series.ct-series-a .ct-bar,\n.ct-chart .ct-series.ct-series-a .ct-line,\n.ct-chart .ct-series.ct-series-a .ct-point,\n.ct-chart .ct-series.ct-series-a .ct-slice-donut {\n    stroke: #1b82ec;\n}\n\n.ct-chart .ct-series.ct-series-b .ct-bar,\n.ct-chart .ct-series.ct-series-b .ct-line,\n.ct-chart .ct-series.ct-series-b .ct-point,\n.ct-chart .ct-series.ct-series-b .ct-slice-donut {\n    stroke: #29bbe3;\n}\n\n.ct-chart .ct-series.ct-series-c .ct-bar,\n.ct-chart .ct-series.ct-series-c .ct-line,\n.ct-chart .ct-series.ct-series-c .ct-point,\n.ct-chart .ct-series.ct-series-c .ct-slice-donut {\n    stroke: #f5b225;\n}\n\n.ct-chart .ct-series.ct-series-d .ct-bar,\n.ct-chart .ct-series.ct-series-d .ct-line,\n.ct-chart .ct-series.ct-series-d .ct-point,\n.ct-chart .ct-series.ct-series-d .ct-slice-donut {\n    stroke: #2a3142;\n}\n\n.ct-chart .ct-series.ct-series-e .ct-bar,\n.ct-chart .ct-series.ct-series-e .ct-line,\n.ct-chart .ct-series.ct-series-e .ct-point,\n.ct-chart .ct-series.ct-series-e .ct-slice-donut {\n    stroke: #35a989;\n}\n\n.ct-chart .ct-series.ct-series-f .ct-bar,\n.ct-chart .ct-series.ct-series-f .ct-line,\n.ct-chart .ct-series.ct-series-f .ct-point,\n.ct-chart .ct-series.ct-series-f .ct-slice-donut {\n    stroke: #f16c69;\n}\n\n.ct-chart .ct-series.ct-series-g .ct-bar,\n.ct-chart .ct-series.ct-series-g .ct-line,\n.ct-chart .ct-series.ct-series-g .ct-point,\n.ct-chart .ct-series.ct-series-g .ct-slice-donut {\n    stroke: #f9f9f9;\n}\n\n.ct-series-a .ct-area,\n.ct-series-a .ct-slice-pie {\n    fill: #1b82ec;\n}\n\n.ct-series-b .ct-area,\n.ct-series-b .ct-slice-pie {\n    fill: #f5b225;\n}\n\n.ct-series-c .ct-area,\n.ct-series-c .ct-slice-pie {\n    fill: #2a3142;\n}\n\n.chartist-tooltip {\n    position: absolute;\n    display: inline-block;\n    opacity: 0;\n    min-width: 10px;\n    padding: 2px 10px;\n    border-radius: 3px;\n    -moz-border-radius: 3px;\n    background-clip: padding-box;\n    background: #2a3142;\n    color: #ffffff;\n    text-align: center;\n    pointer-events: none;\n    z-index: 1;\n    -webkit-transition: opacity 0.2s linear;\n    transition: opacity 0.2s linear;\n}\n\n.chartist-tooltip.tooltip-show {\n    opacity: 1;\n}\n\n.c3 svg {\n    max-width: 100%;\n}\n\n.c3-tooltip td>span {\n    background: #2a3142;\n}\n\n.c3-tooltip td {\n    border-left: none;\n}\n\n.c3-tooltip {\n    -webkit-box-shadow: 0 8px 40px 0 rgba(0, 0, 0, 0.12);\n    box-shadow: 0 8px 40px 0 rgba(0, 0, 0, 0.12);\n    opacity: 1;\n}\n\n.c3-chart-arcs-title {\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.c3-tooltip tr {\n    border: none !important;\n}\n\n.c3-tooltip th {\n    background-color: #2a3142;\n}\n\n.c3-tooltip .value {\n    font-weight: 600;\n}\n\n.c3-line {\n    stroke-width: 2px;\n}\n\n.c3-legend-item {\n    font-size: 13px;\n}\n\n.jqstooltip {\n    -webkit-box-sizing: content-box;\n    box-sizing: content-box;\n    background-color: #ffffff !important;\n    padding: 5px 10px !important;\n    border-radius: 3px;\n    border-color: #ffffff !important;\n    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);\n    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);\n}\n\n.jqsfield {\n    font-size: 12px !important;\n    line-height: 18px !important;\n    color: #2a3142 !important;\n}\n\n.widget-chart li {\n    width: 31.5%;\n    display: inline-block;\n    padding: 0;\n}\n\n.widget-chart li i {\n    font-size: 22px;\n}\n\n.mini-stat {\n    overflow: hidden;\n}\n\n.mini-stat .mini-stat-desc .verti-label {\n    -webkit-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n    position: absolute;\n    top: 44px;\n    right: -9px;\n    letter-spacing: 2px;\n}\n\n.mini-stat .mini-stat-icon i {\n    position: absolute;\n    right: 46px;\n    top: -35px;\n    color: rgba(255, 255, 255, 0.3);\n}\n\n.recent-activity-tab .nav-item {\n    position: relative;\n    padding-top: 30px;\n    border-top: 2px solid #e9ecef;\n}\n\n.recent-activity-tab .nav-item::before {\n    content: \"\";\n    position: absolute;\n    top: -7px;\n    width: 12px;\n    height: 12px;\n    background: #1b82ec;\n    border-radius: 50%;\n    border: 2px solid rgba(255, 255, 255, 0.4);\n}\n\n.recent-activity-tab .nav-item .nav-link {\n    color: #2a3142;\n    border-radius: 30px;\n    position: relative;\n}\n\n.recent-activity-tab .nav-item .nav-link.active {\n    color: #ffffff;\n}\n\n.recent-activity-tab .nav-item .nav-link.active:before {\n    content: \"\";\n    position: absolute;\n    width: 20px;\n    height: 16px;\n    background: #1b82ec;\n    -webkit-transform: rotate(-60deg) skew(60deg);\n    transform: rotate(-60deg) skew(60deg);\n    top: -7px;\n}\n\n@media (max-width: 420px) {\n    .recent-activity-tab .nav-item .nav-link.active:before {\n        left: 12px;\n    }\n}\n\n.inbox-wid .inbox-item {\n    position: relative;\n    border-bottom: 1px solid rgba(243, 243, 243, 0.9);\n    overflow: hidden;\n    padding: 10px 0;\n}\n\n.inbox-wid .inbox-item .inbox-item-date {\n    font-size: 11px;\n    position: absolute;\n    right: 7px;\n    top: 8px;\n}\n\n.order-table .badge {\n    padding: 0.5em 0.6em;\n    text-transform: uppercase;\n}\n\n.order-table .badge-primary {\n    background: rgba(27, 130, 236, 0.5);\n}\n\n.order-table .badge-success {\n    background: rgba(53, 169, 137, 0.5);\n}\n\n.order-table .badge-warning {\n    background: rgba(245, 178, 37, 0.5);\n}\n\n.dashboard-charts {\n    height: 300px;\n}\n\n.dashboard-ds .table-hover tbody tr:hover,\n.dashboard-ds .table-striped tbody tr:nth-of-type(odd),\n.dashboard-ds .thead-default th {\n    background-color: #f9f9f9;\n}\n\n.dashboard-ds .card {\n    border: none;\n    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);\n    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);\n    margin-bottom: 30px;\n}\n\nh1.logoheading {\n    font-size: 20px;\n    color: #fff;\n    padding-top: 9px;\n}\n\n.row-tails {\n    display: flex;\n    width: 100%;\n    background: #ffffff;\n    border-radius: 6px;\n}\n\n.row-tails .mini-stat-icon {\n    color: #1b82ec;\n    width: 70px;\n    height: 70px;\n    background: #f0f7ff;\n    border-radius: 5px;\n    padding: 15px;\n    display: flex;\n    justify-content: center;\n    margin-right: 10px;\n}\n\n.row-tails .mini-stat-desc {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.row-tails .mini-stat-desc h3 {\n    font-weight: 600;\n    font-size: 22px;\n}\n\n.row-tails .mini-stat-desc h6 {\n    font-size: 13px;\n    color: #bbbbbb;\n    font-weight: 400;\n}\n\n.row-tails .mini-stat-desc h5 {\n    font-size: 13px;\n    margin-top: 0;\n    margin-bottom: 25px;\n    margin-left: 30px;\n}\n\n.row-tails .mini-stat-desc h5 i {\n    font-weight: 700;\n}\n\n.row-tails .card-body {\n    display: flex;\n    position: relative;\n    width: 20%;\n    padding: 15px;\n}\n\n.row-tails .card-body:after {\n    content: \"\";\n    position: absolute;\n    width: 2px;\n    height: 60%;\n    top: 20%;\n    background: #eaeaea;\n    right: 0px;\n}\n\n.row-tails .card-body:last-child:after {\n    background: #ffffff;\n}\n\nul.chart-ul {\n    display: flex;\n    justify-content: space-between;\n    padding: 0px;\n    margin: 0px;\n    list-style-type: none;\n}\n\nul.chart-ul li p {\n    font-size: 14px;\n    color: #bbbbbb;\n    font-weight: 400;\n    margin-bottom: 0;\n}\n\nul.chart-ul li p i {\n    font-size: 10px;\n    padding-right: 3px;\n    color: #1b82ec;\n}\n\nul.chart-ul li p:nth-child(2) i {\n    color: #29bbe3;\n}\n\nul.chart-ul li p:nth-child(3) i {\n    color: #f5b225;\n}\n\nul.chart-ul li h5 {\n    font-size: 13px;\n    margin-top: 0;\n    margin-bottom: 25px;\n    margin-left: 30px;\n}\n\n.chart-row .header-title {\n    font-size: 16px;\n    border-bottom: 1px solid #ece9e9;\n    padding-bottom: 10px;\n}\n\n.credit-card img.d-block.img-fluid {\n    width: 300px;\n    height: 200px;\n}\n\nul.credit-card-ul {\n    padding: 0px;\n    margin: 0px;\n    list-style-type: none;\n}\n\nul.credit-card-ul li {\n    display: flex;\n    justify-content: space-between;\n    height: 75px;\n    align-items: center;\n    border-bottom: 1px solid #ece9e9;\n}\n\nul.credit-card-ul li:last-child {\n    border: 0px;\n}\n\nul.credit-card-ul li .pic {\n    width: 85px;\n    background: #f3f3f3;\n    height: 55px;\n    padding: 20px;\n    border-radius: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 20px;\n}\n\nul.credit-card-ul li .pic img {\n    width: 100%;\n}\n\nul.credit-card-ul li h1 {\n    color: #0d2f52;\n    font-size: 20px;\n    margin: 0px;\n}\n\nul.credit-card-ul li .details {\n    display: flex;\n    align-items: center;\n}\n\nul.credit-card-ul li p {\n    margin: 0px;\n    font-size: 14px;\n    color: #bbbbbb;\n    font-weight: 400;\n}\n\nul.credit-card-ul li .rate {\n    min-width: 100px;\n}\n\nul.credit-card-ul li .rate h1 i {\n    float: right;\n    font-weight: 700;\n}\n\n.chart-row.credit-card .carousel {\n    position: relative;\n    padding-bottom: 62px;\n    padding-top: 30px;\n}\n\n.chart-row.credit-card .carousel-indicators li {\n    width: 8px;\n    height: 8px;\n    background-color: #cccccc;\n    border-radius: 50%;\n}\n\n.chart-row.credit-card .carousel-indicators .active {\n    background-color: #f5b225;\n}\n\n.chart-row.credit-card .carousel-control-next,\n.chart-row.credit-card .carousel-control-prev {\n    bottom: 25px;\n    top: auto;\n    font-size: 20px;\n    color: #424242;\n}\n\n.chart-row .card {\n    border-radius: 7px;\n}\n\n.chart-row table th {\n    font-weight: 600;\n    color: #000;\n}\n\n.table-responsive.ct-chart {\n    margin-top: 25px;\n    display: flex;\n    align-items: center;\n    height: auto;\n}\n\n.table-view .heading {\n    display: flex;\n    border: 1px solid #d2d2d2;\n    margin-top: 15px;\n}\n\n.heading .item {\n    width: 50%;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 17px;\n    background: #ffffff;\n    color: #333333;\n    padding: 5px 5px;\n    border-right: 2px solid #cecece;\n}\n\n.heading .item:last-child {\n    border: 0px;\n}\n\n.table-view .heading2 {\n    display: flex;\n    border: 1px solid #dadada;\n}\n\n.heading2 .item {\n    width: 50%;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    border-right: 2px solid #dadada;\n}\n\n.heading2 .item:last-child {\n    border: 0px;\n}\n\n.heading2 .item .box {\n    width: 25%;\n    border-right: 2px solid #dadada;\n}\n\n.heading2 .item .box:last-child {\n    border: 0px;\n}\n\n.heading2 .item:last-child {\n    border: 0px;\n}\n\n.heading2 .item .item2 {\n    font-size: 15px;\n    line-height: 19px;\n    text-align: center;\n    padding: 7px 5px;\n    background: #f1f1f1;\n    height: 52px;\n    display: flex;\n    align-items: center;\n}\n\n.heading2 .item .box span {\n    display: block;\n    padding: 7px 5px;\n    font-size: 17px;\n    color: #333333;\n}\n\n.heading2 .item .item2:last-child {\n    border: 0px;\n}\n\n.table-responsive.ct-chart.table2 {\n    margin-top: 25px;\n    display: flex;\n    align-items: center;\n    height: auto;\n}\n\n@media (max-width: 1199px) {\n    .row-tails .mini-stat-icon {\n        width: 60px;\n        height: 60px;\n        padding: 13px;\n        margin-right: 10px;\n    }\n\n    .row-tails .mini-stat-desc h3 {\n        font-size: 20px;\n    }\n\n    .row-tails .card-body {\n        padding: 10px;\n    }\n\n    .row-tails .mini-stat-desc h6 {\n        font-size: 11px;\n    }\n\n    ul.chart-ul li h3 {\n        font-size: 25px;\n    }\n\n    ul.chart-ul li p {\n        font-size: 13px;\n    }\n\n    ul.credit-card-ul li {\n        height: 66px;\n    }\n\n    ul.credit-card-ul li .pic {\n        width: 80px;\n        height: 50px;\n        padding: 18px;\n        margin-right: 18px;\n    }\n\n    ul.credit-card-ul li h1 {\n        font-size: 17px;\n    }\n\n    ul.credit-card-ul li p {\n        font-size: 13px;\n    }\n\n    .credit-card img.d-block.img-fluid {\n        height: 165px;\n    }\n}\n\n@media (max-width: 991px) {\n    .chart-row.chart-box .col-xl-4.col-md-4 {\n        max-width: inherit;\n        flex: auto;\n        width: 100%;\n    }\n\n    .row-tails .mini-stat-desc h5 {\n        font-size: 10px;\n        margin-left: 15px;\n    }\n\n    .row-tails .mini-stat-icon {\n        width: 45px;\n        height: 45px;\n        padding: 10px;\n        margin-right: 12px;\n    }\n\n    .row-tails .mini-stat-desc h3 {\n        font-size: 15px;\n    }\n\n    .row-tails .mini-stat-desc h6 {\n        font-size: 10px;\n    }\n\n    ul.credit-card-ul li {\n        height: 55px;\n    }\n\n    ul.credit-card-ul li .pic {\n        width: 70px;\n        height: 40px;\n        padding: 15px;\n        margin-right: 15px;\n    }\n\n    ul.credit-card-ul li h1 {\n        font-size: 15px;\n    }\n\n    ul.credit-card-ul li p {\n        font-size: 12px;\n    }\n\n    .credit-card img.d-block.img-fluid {\n        height: 121px;\n    }\n}\n\n@media (max-width: 767px) {\n    .row-tails {\n        flex-wrap: wrap;\n    }\n\n    .row-tails .card-body {\n        width: 50%;\n    }\n\n    .row-tails .mini-stat-desc {\n        width: 100%;\n    }\n\n    .row-tails .mini-stat-desc .text-white {\n        width: calc(100% - 120px);\n    }\n\n    .row-tails .mini-stat-desc h5 {\n        width: 75px;\n        font-size: 13px;\n    }\n\n    .row-tails .mini-stat-icon {\n        width: 75px;\n        height: 60px;\n        padding: 13px;\n        margin-right: 15px;\n    }\n\n    .row-tails .mini-stat-desc h3 {\n        font-size: 22px;\n    }\n\n    .row-tails .mini-stat-desc h6 {\n        font-size: 14px;\n    }\n\n    .credit-card img.d-block.img-fluid {\n        height: 165px;\n    }\n\n    ul.credit-card-ul li .rate {\n        min-width: 75px;\n    }\n\n    ul.credit-card-ul li h1 {\n        font-size: 14px;\n    }\n\n    .row-tails .card-body:nth-child(2)::after {\n        display: none;\n    }\n\n    .row-tails .card-body:nth-child(4)::after {\n        display: none;\n    }\n}\n\n@media (max-width: 550px) {\n    .row-tails {\n        flex-direction: column;\n    }\n\n    .row-tails .card-body {\n        width: 100%;\n    }\n\n    .row-tails .card-body:after {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
